import {
  transformVoucher,
  transformVoucherBalance,
  transformVouchersList,
} from '@/common/integrations/menhir/employee/vouchers/vouchers.dto';
import {
  IMenhirVoucherBalance,
  IMenhirVoucherEnvelope,
  IMenhirVoucherListEnvelope,
  VoucherType,
} from '@/common/integrations/menhir/employee/vouchers/vouchers.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import {
  MENHIR_ENDPOINTS,
  endpointFor,
} from '@/common/integrations/menhir/menhir.endpoints';
import {
  ICreateVoucherRequestParams,
  ListVouchersRequestParams,
} from './vouchers.types';

export const createVoucher = ({
  payload: { amount, memberId, establishmentId, confirmVoucherCreation, type },
  config,
}: ICreateVoucherRequestParams) => {
  return menhirClient
    .post<null, IMenhirVoucherEnvelope>(
      endpointFor(MENHIR_ENDPOINTS.EMPLOYEE.VOUCHERS.ROOT, type),
      {
        voucher: {
          family_member_id: memberId,
          establishment_id: establishmentId,
          amount: {
            amount: amount.amount,
            currency: amount.currency,
          },
          confirm_voucher_creation: confirmVoucherCreation,
        },
      },
      config
    )
    .then((envelope) => {
      return envelope;
    })
    .then((envelope) => transformVoucher(envelope.voucher));
};

export const getVouchers = ({ type }: ListVouchersRequestParams) =>
  menhirClient
    .get<null, IMenhirVoucherListEnvelope>(
      endpointFor(MENHIR_ENDPOINTS.EMPLOYEE.VOUCHERS.ROOT, type)
    )
    .then((envelope) => {
      return envelope;
    })
    .then((envelope) => transformVouchersList(envelope.vouchers));

export const getVoucher = (type: VoucherType, voucherId: string) =>
  menhirClient
    .get<null, IMenhirVoucherEnvelope>(
      endpointFor(MENHIR_ENDPOINTS.EMPLOYEE.VOUCHERS.DETAIL, type, voucherId)
    )
    .then((envelope) => {
      return envelope;
    })
    .then((envelope) => transformVoucher(envelope.voucher));

export const getVouchersBalance = (type?: VoucherType) =>
  menhirClient
    .get<null, { balance: IMenhirVoucherBalance }>(
      endpointFor(MENHIR_ENDPOINTS.EMPLOYEE.VOUCHERS.BALANCE),
      {
        params: {
          type,
        },
      }
    )
    .then((envelope) => transformVoucherBalance(envelope.balance));
